const actions = {
    SET_USER: 'SET_USER',
    SET_TOKEN: 'SET_TOKEN',
    SET_LOADING:"SET_LOADING",
    SET_LOGGEDIN:"SET_LOGGEDIN",
    SET_REGISTRATION_DETAILS:"SET_REGISTRATION_DETAILS",
    setUser: (data) => {
        return {
            type: actions.SET_USER,
            data,
        };
    },
    setToken: (data) => {
        return {
            type: actions.SET_TOKEN,
            data,
        };
    },
    setLoading: (data) => {
        return {
            type: actions.SET_LOADING,
            data,
        };
    },
    setLoggedIn: (data) => {
        return {
            type: actions.SET_LOGGEDIN,
            data,
        };
    },
    setRegistraionDetails: (data) => {
        return {
            type: actions.SET_REGISTRATION_DETAILS,
            data,
        };
    },
};

export default actions;
